import { GraphQLClient } from "graphql-request";
import { apiUrl } from "./config/env";

const graphQLClient = new GraphQLClient(apiUrl, {
  headers: {
    "Content-Type": "application/json",
  },
  credentials: "include",
  fetch: (input, init) => {
    return fetch(input, {
      ...init,
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache',
    });
  },
});

export default graphQLClient;
